<div class="content popup-content white-bg-float-label" style="height: 100px !important;">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form [formGroup]="ChangePasswordFormGroup" class="form_field" (ngSubmit)="changePasswordSubmit()" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto">
            <div class="popup-header">
                <mat-toolbar class="mat-accent m-0"style="background-color: #2e5d97 !important;">
                    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="title dialog-title">Change Password</span>
                        <button mat-icon-button [mat-dialog-close]="true" aria-label="Close dialog" tabindex="-1">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-toolbar-row>
                </mat-toolbar>
            </div>
            <div fxLayout.xs="column" fxLayoutAlign="center center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>Old Password</mat-label>
                    <input type="password" matInput formControlName="old_password">
                    <mat-error *ngIf="ChangePasswordFormGroup.get('old_password').hasError('required')">Old Password is required
                    </mat-error>
                </mat-form-field>
            </div>
            <div [fxLayout]="direction" fxLayout.xs="column" fxLayoutAlign="center center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>New Password</mat-label>
                    <input type="password" matInput formControlName="new_password">
                    <mat-error *ngIf="ChangePasswordFormGroup.get('new_password').hasError('required')">New password is required
                    </mat-error>
                    <mat-error>{{ getErrorMessage('new_password') }}</mat-error>
                </mat-form-field>
            </div>


            <!-- <input type="range" (change)="updatePasswordLength($event)" min="8" max="32" step="1" value="{{passwordLenght}}" /> -->
            <!-- <input type="text" value="{{passwordLenght}}" /> -->
            <!-- <div class="flex">
                <span *ngFor="let checkbox of checkboxes">
                    <input type="checkbox" (change)="updateCheckboxValue($event)" id="{{checkbox.id}}" [checked]="checkbox.checked" />
                    <label for="{{checkbox.id}}">{{checkbox.label}}</label>
                  </span>
            </div> -->

            <div class="example-button-row" fxLayoutAlign="left">
                <a mat-raised-button color="accent" (click)="generatePassword()">{{buttonLabel}}</a>
                <input style="font-size: 16px;color: #1c5e97;" id="passwordOutput" #passwordOutput value="{{newPasswordGenerate}}" readonly/>
            </div>



            <div [fxLayout]="direction" fxLayout.xs="column" fxLayoutAlign="center center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>Confirm Password</mat-label>
                    <input type="password" matInput formControlName="confirm_password">
                    <mat-error *ngIf="ChangePasswordFormGroup.get('confirm_password').hasError('required')">
                        Confirm password is required
                    </mat-error>
                    <mat-error *ngIf="!ChangePasswordFormGroup.get('confirm_password').hasError('required') &&
                    ChangePasswordFormGroup.get('confirm_password').hasError('passwordsNotMatching')">
                        Password and Confirm password should match
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="example-button-row" fxLayoutAlign="center">
                <button mat-raised-button color="accent" class="mr-12 submit-button">Submit</button>
                <!-- <a mat-raised-button color="accent" (click)="dialogClose()">Cancel</a> -->
            </div>
        </form>

    </div>
</div>